export enum BannerManagementCategoryEnum {
  HOME = 'homebanner',
  PROMOTIONS = 'Recommendedbanner',
}
